module.exports = __webpack_public_path__ + "img/revenue.8413b973.svg";